import React from 'react';
import PropTypes from 'prop-types';
import ForeignAddressInput from './ForeignAddressInput';
import BrazilianAddressInput from './BrazilianAddressInput';
import AlternateField from '../AlternateField';

function AddressInput({ foreignBuyer, className, ...props }) {
  return (
    <div className={className}>
      <AlternateField visible={!foreignBuyer}>
        <BrazilianAddressInput {...props} />
      </AlternateField>
      <AlternateField visible={foreignBuyer}>
        <ForeignAddressInput {...props} />
      </AlternateField>
    </div>
  );
}

AddressInput.propTypes = {
  foreignBuyer: PropTypes.bool,
  className: PropTypes.string,
};

AddressInput.defaultProps = {
  foreignBuyer: false,
  className: undefined,
};

export default AddressInput;



// WEBPACK FOOTER //
// ./src/site-render/src/RegisterExtension/AddressInput/AddressInput.js